import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { ToastComponent } from './layout/toast/toast.component';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { refreshInterceptor } from './core/interceptors/refresh.interceptor';
import { tenantInterceptor } from './core/interceptors/tenant.interceptor';
import { SpinnerOverlayComponent } from './layout/spinner-overlay/spinner-overlay.component';
import { BrandingService } from './core/branding/branding.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    LayoutModule,
    ToastComponent,
    SpinnerOverlayComponent,
  ],
  providers: [
    provideHttpClient(
      withXhr(),
      withInterceptors([loadingInterceptor, tenantInterceptor, authInterceptor, refreshInterceptor]),
      withInterceptorsFromDi(),
    ),
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    // Tenant branding for a stored session, before the shell's first paint (no-op when unbranded).
    provideAppInitializer(() => inject(BrandingService).init()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
